import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useParams, useNavigate } from 'react-router-dom'
import { message } from 'antd'
import MyInput from '../components/input'
import MyButton from '../components/button'

export default function Login() {
  const { schoolOid } = useParams()
  const navigate = useNavigate()
  const [merchantDetail, setMerchantDetail] = useState({})
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  useEffect(() => {
    axios.post('/c/kf_b/merchant/get', { 
      merchant_oid: schoolOid 
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setMerchantDetail(response.data)
        } else {
          message.warning(response.msg)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [schoolOid])

  const handleLogin = () => {
    setErrorMsg({})
    if (!formValue.username) {
      setErrorMsg({ usernameEmpty: '用户名不能为空' })
      return
    }
    if (!formValue.password) {
      setErrorMsg({ passwordEmpty: '密码不能为空' })
      return
    }

    axios.post('/c/kf_b/login', {
      merchant_oid: schoolOid,
      username: formValue.username,
      password: formValue.password
    })
      .then(function (response) {
        if (response.errcode === 0) {
          localStorage.setItem('token', response.data.access_token)
          localStorage.setItem('uuid', response.data.oid)
          localStorage.setItem('oid', schoolOid)
          navigate('/home')
        } else if (response.errcode === 1) {
          setErrorMsg({ accountError: response.msg })
        } else if (response.errcode === 2) {
          setErrorMsg({ passwordError: response.msg })
        }
      })
      .catch(function (error) {
        console.error('网络请求异常:', error)
      })
  }

  return (
    <div className='login-page'>
      <div className='login-top'>
        <div className='login-logo'>
          <img src="/images/logo.jpg" alt="" />
          <p>云招客服</p>
        </div>
      </div>

      <form className='login-form'>
        <div className='login-merchant'>
          <img src={merchantDetail.logo} alt="" />
          <p>{merchantDetail.name}</p>
        </div>

        <MyInput
          id="username"
          autoFocus
          autoComplete='on'
          label="用户名"
          placeholder='请输入用户名'
          value={formValue.username}
          onChange={setFormValue}
          errorMsg={errorMsg.usernameEmpty || errorMsg.accountError}
        />
        <MyInput
          id="password"
          type="password"
          visibilityToggle={false}
          label="密码"
          placeholder='请输入密码'
          value={formValue.password}
          onChange={setFormValue}
          errorMsg={errorMsg.passwordEmpty || errorMsg.passwordError}
        />
        <MyButton 
          onClick={handleLogin} 
          buttonText='登录'
          style={{ width: '100%', marginTop: '50px' }}
        />
      </form>

      <div className='login-sign'>© 2024-2025 yunzhaosoft.com, all rights reserved | 广西云招教育科技有限公司 | 桂ICP备2024030510号</div>
    </div>
  )
}
